(() => {
  function byId(id) {
    return document.getElementById(id);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function normalizeImageUrl(url, width) {
    if (!url) {
      return "";
    }
    const normalized = String(url).startsWith("//") ? `https:${url}` : String(url);
    if (!width) {
      return normalized;
    }
    if (normalized.includes("width=")) {
      return normalized;
    }
    return normalized.includes("?") ? `${normalized}&width=${width}` : `${normalized}?width=${width}`;
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const fallbackCurrency = "USD";
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || fallbackCurrency;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency
      }).format(value);
    } catch (error) {
      return `$${value.toFixed(2)}`;
    }
  }

  function initDrawer() {
    const drawerButton = byId("navDrawerBtn");
    const drawerCloseButton = byId("navDrawerBtnB");
    const drawer = byId("navigationDrawer");

    if (!drawerButton || !drawer) {
      return;
    }

    const closeButtons = drawer.querySelectorAll("[data-nav-close]");
    const drawerLinks = drawer.querySelectorAll(".navigation-drawer a");
    const transitionMs = 260;

    function openSideNav() {
      if (typeof window.closeUtilityPanels === "function") {
        window.closeUtilityPanels();
      }
      drawer.hidden = false;
      window.requestAnimationFrame(() => {
        drawer.classList.add("is-open");
      });
      drawerButton.classList.add("is-active");
      drawerButton.setAttribute("aria-expanded", "true");
      if (drawerCloseButton) {
        drawerCloseButton.classList.add("is-active");
      }
      document.body.classList.add("navigation-drawer-open");
    }

    function closeSideNav() {
      drawer.classList.remove("is-open");
      drawerButton.classList.remove("is-active");
      drawerButton.setAttribute("aria-expanded", "false");
      if (drawerCloseButton) {
        drawerCloseButton.classList.remove("is-active");
      }
      document.body.classList.remove("navigation-drawer-open");

      window.setTimeout(() => {
        if (!drawer.classList.contains("is-open")) {
          drawer.hidden = true;
        }
      }, transitionMs);
    }

    window.openSideNav = openSideNav;
    window.closeSideNav = closeSideNav;

    drawerButton.addEventListener("click", () => {
      if (drawer.classList.contains("is-open")) {
        closeSideNav();
      } else {
        openSideNav();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closeSideNav);
    });

    drawerLinks.forEach((link) => {
      link.addEventListener("click", closeSideNav);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) {
        closeSideNav();
      }
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get("drawer") === "open" || window.location.hash === "#drawer-open") {
      openSideNav();
    }
  }

  function initTopNavDropdowns() {
    const navLinks = document.querySelector(".navigation-top__links");
    if (!navLinks) {
      return;
    }

    const dropdowns = Array.from(navLinks.querySelectorAll(".navigation-top__dropdown"));
    if (!dropdowns.length) {
      return;
    }

    const desktopQuery = window.matchMedia("(min-width: 900px)");
    const closeDelayMs = 140;
    const closeTimers = new WeakMap();

    function clearCloseTimer(dropdown) {
      const timerId = closeTimers.get(dropdown);
      if (!timerId) {
        return;
      }
      window.clearTimeout(timerId);
      closeTimers.delete(dropdown);
    }

    function scheduleClose(dropdown) {
      clearCloseTimer(dropdown);
      const timerId = window.setTimeout(() => {
        dropdown.open = false;
        setExpanded(dropdown, false);
        closeTimers.delete(dropdown);
      }, closeDelayMs);
      closeTimers.set(dropdown, timerId);
    }

    function setExpanded(dropdown, expanded) {
      const summary = dropdown.querySelector("summary");
      if (summary) {
        summary.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
    }

    function closeAll(exceptDropdown) {
      dropdowns.forEach((dropdown) => {
        clearCloseTimer(dropdown);
        if (exceptDropdown && dropdown === exceptDropdown) {
          return;
        }
        if (dropdown.open) {
          dropdown.open = false;
        }
        setExpanded(dropdown, false);
      });
    }

    dropdowns.forEach((dropdown) => {
      const summary = dropdown.querySelector("summary");
      if (!(summary instanceof HTMLElement)) {
        return;
      }

      summary.setAttribute("aria-haspopup", "menu");
      if (dropdown.open) {
        dropdown.open = false;
      }
      setExpanded(dropdown, false);

      summary.addEventListener("click", (event) => {
        if (!desktopQuery.matches) {
          return;
        }
        event.preventDefault();
        clearCloseTimer(dropdown);
        const shouldOpen = !dropdown.open;
        closeAll(dropdown);
        dropdown.open = shouldOpen;
        setExpanded(dropdown, shouldOpen);
      });

      dropdown.addEventListener("mouseenter", () => {
        if (!desktopQuery.matches) {
          return;
        }
        clearCloseTimer(dropdown);
        closeAll(dropdown);
        dropdown.open = true;
        setExpanded(dropdown, true);
      });

      dropdown.addEventListener("mouseleave", () => {
        if (!desktopQuery.matches) {
          return;
        }
        scheduleClose(dropdown);
      });

      dropdown.addEventListener("focusin", () => {
        if (!desktopQuery.matches) {
          return;
        }
        clearCloseTimer(dropdown);
        closeAll(dropdown);
        dropdown.open = true;
        setExpanded(dropdown, true);
      });

      dropdown.addEventListener("focusout", (event) => {
        if (!desktopQuery.matches) {
          return;
        }
        const nextTarget = event.relatedTarget;
        if (nextTarget instanceof Node && dropdown.contains(nextTarget)) {
          return;
        }
        scheduleClose(dropdown);
      });
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      if (!navLinks.contains(target)) {
        closeAll();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAll();
      }
    });

    const onMediaQueryChange = (mediaQueryEvent) => {
      if (!mediaQueryEvent.matches) {
        closeAll();
      }
    };

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", onMediaQueryChange);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(onMediaQueryChange);
    }
  }

  function initStickyTopNav() {
    const topNav = byId("NavigationTop");
    if (!topNav) {
      return;
    }

    const topNavSection = topNav.closest(".shopify-section");
    if (topNavSection) {
      topNavSection.classList.add("navigation-top-section");
    }

    const scrolledClass = "is-scrolled";
    const threshold = 8;

    const updateStickyState = () => {
      topNav.classList.toggle(scrolledClass, window.scrollY > threshold);
    };

    updateStickyState();
    window.addEventListener("scroll", updateStickyState, { passive: true });
    window.addEventListener("resize", updateStickyState);
  }

  function initUtilityPanels() {
    const cartPanel = byId("cartPanel");
    const accountPanel = byId("accountPanel");
    const cartToggles = document.querySelectorAll("[data-cart-panel-toggle]");
    const accountToggles = document.querySelectorAll("[data-account-panel-toggle]");

    if (!cartPanel && !accountPanel) {
      return;
    }

    const transitionMs = 280;
    const panels = {
      cart: {
        element: cartPanel,
        toggles: cartToggles
      },
      account: {
        element: accountPanel,
        toggles: accountToggles
      }
    };

    function setExpanded(toggleSet, expanded) {
      toggleSet.forEach((toggle) => {
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
    }

    function anyOpen() {
      return Object.values(panels).some((panel) => panel.element && panel.element.classList.contains("is-open"));
    }

    function openPanel(name) {
      const target = panels[name];
      if (!target || !target.element) {
        return;
      }

      if (typeof window.closeSideNav === "function") {
        window.closeSideNav();
      }

      Object.keys(panels).forEach((panelName) => {
        if (panelName !== name) {
          closePanel(panelName, true);
        }
      });

      target.element.hidden = false;
      window.requestAnimationFrame(() => {
        target.element.classList.add("is-open");
      });
      setExpanded(target.toggles, true);
      document.body.classList.add("utility-panel-open");
    }

    function closePanel(name, immediate) {
      const target = panels[name];
      if (!target || !target.element) {
        return;
      }
      target.element.classList.remove("is-open");
      setExpanded(target.toggles, false);

      const finalize = () => {
        if (!target.element.classList.contains("is-open")) {
          target.element.hidden = true;
        }
        if (!anyOpen()) {
          document.body.classList.remove("utility-panel-open");
        }
      };

      if (immediate) {
        finalize();
      } else {
        window.setTimeout(finalize, transitionMs);
      }
    }

    function closeAllPanels(immediate) {
      closePanel("cart", immediate);
      closePanel("account", immediate);
    }

    window.closeUtilityPanels = closeAllPanels;
    window.openUtilityPanel = openPanel;

    cartToggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        if (cartPanel && cartPanel.classList.contains("is-open")) {
          closePanel("cart");
        } else {
          openPanel("cart");
        }
      });
    });

    accountToggles.forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        if (accountPanel && accountPanel.classList.contains("is-open")) {
          closePanel("account");
        } else {
          openPanel("account");
        }
      });
    });

    Object.entries(panels).forEach(([name, panel]) => {
      if (!panel.element) {
        return;
      }

      panel.element.querySelectorAll("[data-utility-close]").forEach((button) => {
        button.addEventListener("click", () => {
          closePanel(name);
        });
      });

      panel.element.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", () => {
          closeAllPanels();
        });
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && anyOpen()) {
        closeAllPanels();
      }
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get("cart") === "open") {
      openPanel("cart");
    } else if (params.get("account") === "open") {
      openPanel("account");
    }
  }

  function initAjaxCart() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    const cartCount = byId("CartTotalQuantityCount");
    const cartTitle = byId("cartPanelTitle");
    const cartBody = byId("CartPanelBody");
    const toastId = "bookmarkCartToast";
    let toastTimer = null;
    let toastCloseTimer = null;
    let cartMutationInFlight = false;

    function updateCartCount(itemCount) {
      if (!cartCount) {
        return;
      }
      const nextCount = Number(itemCount || 0);
      cartCount.textContent = String(nextCount);
      cartCount.classList.toggle("is-empty", nextCount === 0);
      cartCount.classList.remove("is-pulse");
      window.requestAnimationFrame(() => {
        cartCount.classList.add("is-pulse");
      });
    }

    function updateCartTitle(itemCount) {
      if (!cartTitle) {
        return;
      }
      const label = cartTitle.dataset.titleBase || "Cart";
      const nextCount = Number(itemCount || 0);
      cartTitle.textContent = nextCount > 0 ? `${label} (${nextCount})` : label;
    }

    function renderCartBody(cart) {
      if (!cartBody || !cart) {
        return;
      }

      const cartUrl = cartBody.dataset.cartUrl || "/cart";
      const checkoutUrl = cartBody.dataset.checkoutUrl || "/checkout";
      const allBooksUrl = cartBody.dataset.allBooksUrl || "/collections/all";
      const count = Number(cart.item_count || 0);

      if (count < 1) {
        cartBody.innerHTML = `
          <section class="utility-panel__empty">
            <h3>Your bag is empty</h3>
            <p>Add your next Filipino read and continue to secure Shopify checkout.</p>
            <a href="${escapeHtml(allBooksUrl)}" class="button button--full button--full-width">Browse Books</a>
          </section>
        `;
        return;
      }

      const items = Array.isArray(cart.items) ? cart.items : [];
      const list = items
        .map((item, index) => {
          const lineNumber = index + 1;
          const quantity = Math.max(1, Number(item.quantity || 1));
          const productName = item.product_title || item.title || "Untitled";
          const productUrl = item.url || (item.handle ? `/products/${item.handle}` : cartUrl);
          const variantTitle =
            item.variant_title && item.variant_title !== "Default Title"
              ? `<p>${escapeHtml(item.variant_title)}</p>`
              : "";
          const image = item.image
            ? `<img src="${escapeHtml(normalizeImageUrl(item.image, 280))}" alt="${escapeHtml(productName)}" loading="lazy">`
            : '<span class="utility-panel__meta">No image</span>';
          const removeLabel = `Remove ${productName} from your bag`;
          const decrementLabel = `Decrease quantity for ${productName}`;
          const incrementLabel = `Increase quantity for ${productName}`;
          const quantityLabel = `Quantity for ${productName}`;
          return `
            <article class="utility-panel__cart-item">
              <a href="${escapeHtml(productUrl)}" class="utility-panel__cart-image">${image}</a>
              <section class="utility-panel__cart-details">
                <h3>${escapeHtml(productName)}</h3>
                ${variantTitle}
                <section class="utility-panel__cart-controls">
                  <div class="utility-panel__cart-qty" role="group" aria-label="${escapeHtml(quantityLabel)}">
                    <button
                      type="button"
                      class="utility-panel__cart-qty-btn"
                      data-cart-decrement
                      data-cart-line="${lineNumber}"
                      aria-label="${escapeHtml(decrementLabel)}"
                      ${quantity <= 1 ? "disabled" : ""}
                    >
                      -
                    </button>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      value="${quantity}"
                      class="utility-panel__cart-qty-input"
                      data-cart-qty-input
                      data-cart-line="${lineNumber}"
                      data-cart-current-qty="${quantity}"
                      aria-label="${escapeHtml(quantityLabel)}"
                    >
                    <button
                      type="button"
                      class="utility-panel__cart-qty-btn"
                      data-cart-increment
                      data-cart-line="${lineNumber}"
                      aria-label="${escapeHtml(incrementLabel)}"
                    >
                      +
                    </button>
                  </div>
                  <button
                    type="button"
                    class="utility-panel__cart-remove"
                    data-cart-remove
                    data-cart-line="${lineNumber}"
                    aria-label="${escapeHtml(removeLabel)}"
                  >
                    Remove
                  </button>
                </section>
              </section>
              <aside class="utility-panel__cart-price">
                <p>${formatMoney(item.final_line_price)}</p>
                ${quantity > 1 ? `<span>${formatMoney(item.final_price)} each</span>` : ""}
              </aside>
            </article>
          `;
        })
        .join("");

      cartBody.innerHTML = `
        <section class="utility-panel__cart-list">${list}</section>
        <footer class="utility-panel__footer">
          <section class="utility-panel__total">
            <p>Subtotal</p>
            <p>${formatMoney(cart.total_price)}</p>
          </section>
          <section class="utility-panel__actions">
            <a href="${escapeHtml(cartUrl)}" class="button button--hollow button--full-width">View Cart</a>
            <a href="${escapeHtml(checkoutUrl)}" class="button button--full button--full-width">Checkout</a>
          </section>
        </footer>
      `;
    }

    async function parseResponseError(response, fallback) {
      try {
        const data = await response.json();
        if (data && typeof data.description === "string" && data.description.trim()) {
          return data.description.trim();
        }
        if (data && typeof data.message === "string" && data.message.trim()) {
          return data.message.trim();
        }
        if (data && data.errors) {
          if (typeof data.errors === "string" && data.errors.trim()) {
            return data.errors.trim();
          }
          if (typeof data.errors === "object") {
            const values = Object.values(data.errors).flat();
            const first = values.find((value) => typeof value === "string" && value.trim());
            if (first) {
              return first.trim();
            }
          }
        }
      } catch (error) {
        return fallback;
      }
      return fallback;
    }

    function refreshCartUi(cart) {
      if (!cart) {
        return;
      }
      updateCartCount(cart.item_count);
      updateCartTitle(cart.item_count);
      renderCartBody(cart);
    }

    async function fetchCartJson() {
      const response = await fetch("/cart.js", {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error("Unable to refresh cart.");
      }
      return response.json();
    }

    async function changeCartLine(line, quantity) {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          line,
          quantity
        })
      });

      if (!response.ok) {
        const message = await parseResponseError(response, "Unable to update your bag.");
        throw new Error(message);
      }

      return response.json();
    }

    function getToastElement() {
      let toast = byId(toastId);
      if (toast) {
        return toast;
      }

      toast = document.createElement("section");
      toast.id = toastId;
      toast.className = "cart-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);

      function openCartFromToast() {
        if (typeof window.openUtilityPanel === "function") {
          window.openUtilityPanel("cart");
          return;
        }

        const panel = byId("cartPanel");
        if (panel) {
          panel.hidden = false;
          panel.classList.add("is-open");
          document.body.classList.add("utility-panel-open");
          return;
        }

        const fallbackCartUrl = (cartBody && cartBody.dataset.cartUrl) || "/cart";
        window.location.assign(fallbackCartUrl);
      }

      toast.addEventListener("click", (event) => {
        const target = event.target;
        const targetElement =
          target instanceof Element
            ? target
            : target instanceof Node
              ? target.parentElement
              : null;
        const openCartButton =
          targetElement instanceof Element ? targetElement.closest("[data-toast-open-cart]") : null;

        if (!openCartButton) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(toastTimer);
        window.clearTimeout(toastCloseTimer);
        openCartFromToast();
        toast.classList.remove("is-open");
        toast.classList.remove("is-closing");
      });

      return toast;
    }

    function closeToast() {
      const toast = getToastElement();
      toast.classList.remove("is-open");
      toast.classList.add("is-closing");
      window.clearTimeout(toastCloseTimer);
      toastCloseTimer = window.setTimeout(() => {
        toast.classList.remove("is-closing");
      }, 320);
    }

    function showToast({ title, message, error, eyebrow, showCheckout }) {
      const toast = getToastElement();
      const checkoutUrl = (cartBody && cartBody.dataset.checkoutUrl) || "/checkout";
      const renderCheckoutAction = Boolean(showCheckout);
      const actionsClass = renderCheckoutAction ? "cart-toast__actions" : "cart-toast__actions cart-toast__actions--single";
      const toastDuration = error ? 3300 : 3600;

      window.clearTimeout(toastTimer);
      window.clearTimeout(toastCloseTimer);
      toast.classList.remove("is-open");
      toast.classList.remove("is-closing");
      toast.classList.toggle("cart-toast--error", Boolean(error));
      toast.classList.toggle("cart-toast--success", !error);
      toast.style.setProperty("--cart-toast-duration", `${toastDuration}ms`);

      toast.innerHTML = error
        ? `
          <span class="cart-toast__progress" aria-hidden="true"></span>
          <p class="cart-toast__eyebrow">Bag update</p>
          <h3 class="cart-toast__title">Unable to update your bag</h3>
          <p class="cart-toast__message">${escapeHtml(error)}</p>
          <section class="${actionsClass}">
            <button type="button" class="button button--hollow" data-toast-open-cart>Open Bag</button>
          </section>
        `
        : `
          <span class="cart-toast__progress" aria-hidden="true"></span>
          <p class="cart-toast__eyebrow">${escapeHtml(eyebrow || "Bag updated")}</p>
          <h3 class="cart-toast__title">${escapeHtml(title || "Your bag has been updated")}</h3>
          <p class="cart-toast__message">${escapeHtml(message || "Your bag is ready whenever you are.")}</p>
          <section class="${actionsClass}">
            <button type="button" class="button button--hollow" data-toast-open-cart>Open Bag</button>
            ${renderCheckoutAction ? `<a href="${escapeHtml(checkoutUrl)}" class="button button--full">Checkout</a>` : ""}
          </section>
        `;

      window.requestAnimationFrame(() => {
        toast.classList.add("is-open");
      });
      toastTimer = window.setTimeout(closeToast, toastDuration);
    }

    function setSubmittingState(submitButton, submitting) {
      if (!submitButton) {
        return;
      }

      if (!submitButton.dataset.originalLabel) {
        submitButton.dataset.originalLabel = submitButton.textContent || "Add To Cart";
      }

      if (submitting) {
        submitButton.classList.add("is-loading");
        submitButton.disabled = true;
      } else {
        submitButton.classList.remove("is-loading");
        submitButton.disabled = false;
      }
    }

    async function handleDrawerCartMutation({
      line,
      quantity,
      row,
      message
    }) {
      if (!cartBody || cartMutationInFlight) {
        return;
      }

      cartMutationInFlight = true;
      if (row) {
        row.classList.add("is-updating");
      }

      try {
        const cart = await changeCartLine(line, quantity);
        refreshCartUi(cart);
        showToast({ message });
      } catch (error) {
        showToast({
          error: error && error.message ? error.message : "Unable to update your bag."
        });
      } finally {
        cartMutationInFlight = false;
        if (row) {
          row.classList.remove("is-updating");
        }
      }
    }

    if (cartBody && cartBody.dataset.cartControlsBound !== "true") {
      cartBody.dataset.cartControlsBound = "true";

      cartBody.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }

        const control = target.closest("[data-cart-increment], [data-cart-decrement], [data-cart-remove]");
        if (!(control instanceof HTMLButtonElement)) {
          return;
        }

        event.preventDefault();
        const line = Number(control.dataset.cartLine);
        if (!Number.isInteger(line) || line < 1) {
          return;
        }

        const row = control.closest(".utility-panel__cart-item");
        if (!(row instanceof HTMLElement)) {
          return;
        }

        const titleElement = row.querySelector(".utility-panel__cart-details h3");
        const productTitle = titleElement ? titleElement.textContent.trim() : "This book";
        const quantityInput = row.querySelector("[data-cart-qty-input]");
        const currentQuantity = quantityInput instanceof HTMLInputElement
          ? Math.max(1, Number.parseInt(quantityInput.value, 10) || Number.parseInt(quantityInput.dataset.cartCurrentQty || "1", 10) || 1)
          : 1;

        if (control.hasAttribute("data-cart-remove")) {
          handleDrawerCartMutation({
            line,
            quantity: 0,
            row,
            message: `${productTitle} was removed from your bag.`
          });
          return;
        }

        if (control.hasAttribute("data-cart-increment")) {
          const nextQuantity = currentQuantity + 1;
          handleDrawerCartMutation({
            line,
            quantity: nextQuantity,
            row,
            message: `${productTitle} quantity is now ${nextQuantity}.`
          });
          return;
        }

        if (control.hasAttribute("data-cart-decrement")) {
          const nextQuantity = Math.max(1, currentQuantity - 1);
          if (nextQuantity === currentQuantity) {
            return;
          }
          handleDrawerCartMutation({
            line,
            quantity: nextQuantity,
            row,
            message: `${productTitle} quantity is now ${nextQuantity}.`
          });
        }
      });

      cartBody.addEventListener("change", (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) || !target.hasAttribute("data-cart-qty-input")) {
          return;
        }

        const line = Number(target.dataset.cartLine);
        if (!Number.isInteger(line) || line < 1) {
          return;
        }

        const row = target.closest(".utility-panel__cart-item");
        if (!(row instanceof HTMLElement)) {
          return;
        }

        const titleElement = row.querySelector(".utility-panel__cart-details h3");
        const productTitle = titleElement ? titleElement.textContent.trim() : "This book";
        const currentQuantity = Math.max(1, Number.parseInt(target.dataset.cartCurrentQty || "1", 10));
        const parsedQuantity = Number.parseInt(target.value, 10);
        const nextQuantity = Math.max(1, Number.isFinite(parsedQuantity) ? parsedQuantity : currentQuantity);
        target.value = String(nextQuantity);

        if (nextQuantity === currentQuantity) {
          return;
        }

        handleDrawerCartMutation({
          line,
          quantity: nextQuantity,
          row,
          message: `${productTitle} quantity is now ${nextQuantity}.`
        });
      });
    }

    forms.forEach((form) => {
      if (form.dataset.ajaxCartBound === "true") {
        return;
      }
      form.dataset.ajaxCartBound = "true";

      form.addEventListener("submit", async (event) => {
        const submitter = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
        if (submitter && submitter.disabled) {
          return;
        }
        event.preventDefault();
        setSubmittingState(submitter, true);

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest"
            },
            body: new FormData(form)
          });

          if (!response.ok) {
            const message = await parseResponseError(response, "Unable to add this item.");
            throw new Error(message);
          }

          const addedItem = await response.json();
          const cart = await fetchCartJson();
          refreshCartUi(cart);

          showToast({
            message: `${addedItem.product_title || addedItem.title || "Your item"} was added to your bag.`,
            showCheckout: true
          });
        } catch (error) {
          showToast({
            error: error && error.message ? error.message : "Unable to add this item."
          });
        } finally {
          setSubmittingState(submitter, false);
        }
      });
    });
  }

  function initPageTransitions() {
    const body = document.body;
    const main = byId("main");
    const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const leaveDurationMs = 160;
    const enterDurationMs = 140;
    let isLeaving = false;

    function assignLocation(nextUrl) {
      if (typeof nextUrl === "string" && nextUrl.trim()) {
        window.location.assign(nextUrl);
      }
    }

    window.bookmarkNavigateWithTransition = assignLocation;

    if (!body || !main || reducedMotionQuery.matches) {
      if (body) {
        body.classList.remove("page-transition-entering");
        body.classList.remove("page-transition-leaving");
        body.classList.add("page-transition-ready");
      }
      return;
    }

    function navigateWithTransition(nextUrl) {
      if (isLeaving || !nextUrl) {
        return;
      }

      isLeaving = true;
      body.classList.remove("page-transition-entering");
      body.classList.add("page-transition-ready");
      body.classList.add("page-transition-leaving");

      window.setTimeout(() => {
        window.location.assign(nextUrl);
      }, leaveDurationMs);
    }

    function shouldSkipTransition(event, anchor) {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        isLeaving
      ) {
        return true;
      }

      if (
        anchor.hasAttribute("download") ||
        anchor.hasAttribute("data-account-panel-toggle") ||
        anchor.hasAttribute("data-cart-panel-toggle") ||
        anchor.hasAttribute("data-utility-close") ||
        anchor.closest("[data-no-page-transition]")
      ) {
        return true;
      }

      const target = anchor.getAttribute("target");
      if (target && target.toLowerCase() !== "_self") {
        return true;
      }

      const rawHref = anchor.getAttribute("href");
      if (
        !rawHref ||
        rawHref.startsWith("#") ||
        rawHref.startsWith("mailto:") ||
        rawHref.startsWith("tel:") ||
        rawHref.startsWith("javascript:")
      ) {
        return true;
      }

      let destination = null;
      try {
        destination = new URL(anchor.href, window.location.href);
      } catch (error) {
        return true;
      }

      if (
        destination.origin !== window.location.origin ||
        (destination.protocol !== "http:" && destination.protocol !== "https:")
      ) {
        return true;
      }

      if (
        destination.pathname === window.location.pathname &&
        destination.search === window.location.search &&
        destination.hash
      ) {
        return true;
      }

      if (destination.href === window.location.href) {
        return true;
      }

      return false;
    }

    window.bookmarkNavigateWithTransition = navigateWithTransition;

    body.classList.remove("page-transition-leaving");
    body.classList.add("page-transition-entering");
    window.requestAnimationFrame(() => {
      body.classList.add("page-transition-ready");
    });
    window.setTimeout(() => {
      body.classList.remove("page-transition-entering");
    }, enterDurationMs);

    document.addEventListener(
      "click",
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }

        const anchor = target.closest("a[href]");
        if (!(anchor instanceof HTMLAnchorElement) || shouldSkipTransition(event, anchor)) {
          return;
        }

        event.preventDefault();
        navigateWithTransition(anchor.href);
      },
      true
    );

    window.addEventListener("pageshow", () => {
      isLeaving = false;
      body.classList.remove("page-transition-leaving");
      body.classList.add("page-transition-ready");
    });
  }

  function initSearch() {
    const searchRoot = byId("navigationSearch");
    const input = searchRoot ? searchRoot.querySelector(".js-bookmark-search-input") : null;
    const results = searchRoot ? searchRoot.querySelector(".js-bookmark-search-results") : null;

    if (!input || !results) {
      return;
    }

    let timeoutId = null;
    let requestToken = 0;
    let activeIndex = -1;
    let authorIndexPromise = null;

    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-haspopup", "listbox");

    function openResults() {
      results.hidden = false;
      window.requestAnimationFrame(() => {
        results.classList.add("is-open");
      });
      input.setAttribute("aria-expanded", "true");
    }

    function closeResults() {
      results.classList.remove("is-open");
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
      activeIndex = -1;
      window.setTimeout(() => {
        if (!results.classList.contains("is-open")) {
          results.hidden = true;
        }
      }, 220);
    }

    function getItemImage(product) {
      if (!product || !product.image) {
        return "";
      }
      if (typeof product.image === "string") {
        return product.image;
      }
      if (typeof product.image === "object" && typeof product.image.url === "string") {
        return product.image.url;
      }
      return "";
    }

    function normalizeSearchValue(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
    }

    function getProductKey(product) {
      if (!product || typeof product !== "object") {
        return "";
      }
      if (typeof product.url === "string" && product.url.trim()) {
        return product.url.trim().toLowerCase();
      }
      if (product.id !== null && product.id !== undefined) {
        return String(product.id).toLowerCase();
      }
      return "";
    }

    function getProductAuthor(product) {
      if (!product || typeof product !== "object") {
        return "";
      }
      if (typeof product.author === "string") {
        return product.author.trim();
      }
      return "";
    }

    function setStatus(content, loading) {
      results.innerHTML = `<div class="search-live__status${loading ? " is-loading" : ""}"><p>${escapeHtml(content)}</p></div>`;
      openResults();
    }

    function setActiveItem(nextIndex) {
      const items = results.querySelectorAll(".search-live-item[data-result-index]");
      if (!items.length) {
        activeIndex = -1;
        input.removeAttribute("aria-activedescendant");
        return;
      }

      if (nextIndex < 0) {
        nextIndex = items.length - 1;
      } else if (nextIndex >= items.length) {
        nextIndex = 0;
      }

      activeIndex = nextIndex;
      items.forEach((item, index) => {
        const selected = index === activeIndex;
        item.classList.toggle("is-active", selected);
        item.setAttribute("aria-selected", selected ? "true" : "false");
      });

      const activeItem = items[activeIndex];
      if (activeItem) {
        if (activeItem.id) {
          input.setAttribute("aria-activedescendant", activeItem.id);
        }
        activeItem.scrollIntoView({ block: "nearest" });
      }
    }

    function getProductPriceText(product) {
      if (!product || typeof product !== "object") {
        return "";
      }

      const candidates = [
        product.price,
        product.price_min,
        product.min_price,
        product.compare_at_price
      ];

      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === "") {
          continue;
        }

        if (typeof candidate === "number" && Number.isFinite(candidate)) {
          return formatMoney(candidate);
        }

        if (typeof candidate === "string") {
          const raw = candidate.trim();
          if (!raw) {
            continue;
          }

          if (/[$€£₱]/.test(raw)) {
            return raw;
          }

          const numeric = Number(raw.replace(/,/g, ""));
          if (Number.isFinite(numeric)) {
            if (raw.includes(".")) {
              return formatMoney(Math.round(numeric * 100));
            }
            return formatMoney(numeric);
          }
        }
      }

      return "";
    }

    async function fetchAuthorIndex() {
      if (authorIndexPromise) {
        return authorIndexPromise;
      }

      authorIndexPromise = (async () => {
        const authorProducts = [];
        let page = 1;
        let pages = 1;
        const maxPages = 8;

        while (page <= pages && page <= maxPages) {
          const url = `/search?q=*&type=product&view=author-index&page=${page}`;
          const response = await fetch(url, {
            headers: {
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest"
            }
          });

          if (!response.ok) {
            throw new Error("Author index request failed.");
          }

          const json = await response.json();
          const products = json && Array.isArray(json.products) ? json.products : [];

          for (const product of products) {
            const author = getProductAuthor(product);
            if (!author) {
              continue;
            }
            authorProducts.push(product);
          }

          const totalPages = Number(json && json.pages);
          pages = Number.isInteger(totalPages) && totalPages > 0 ? totalPages : page;
          page += 1;
        }

        return authorProducts;
      })().catch((error) => {
        authorIndexPromise = null;
        throw error;
      });

      return authorIndexPromise;
    }

    function getAuthorMatches(authorProducts, query, existingProducts, limit) {
      if (!Array.isArray(authorProducts) || !authorProducts.length || limit <= 0) {
        return [];
      }

      const normalizedQuery = normalizeSearchValue(query);
      if (!normalizedQuery) {
        return [];
      }

      const matches = [];
      const seenKeys = new Set();
      (existingProducts || []).forEach((product) => {
        const key = getProductKey(product);
        if (key) {
          seenKeys.add(key);
        }
      });

      for (const product of authorProducts) {
        if (matches.length >= limit) {
          break;
        }

        const author = getProductAuthor(product);
        if (!author) {
          continue;
        }

        if (!normalizeSearchValue(author).includes(normalizedQuery)) {
          continue;
        }

        const key = getProductKey(product);
        if (key && seenKeys.has(key)) {
          continue;
        }
        if (key) {
          seenKeys.add(key);
        }

        matches.push(product);
      }

      return matches;
    }

    function renderProducts(products, query) {
      const viewAllUrl = `/search?q=${encodeURIComponent(query)}&type=product`;
      if (!products.length) {
        results.innerHTML = `
          <div class="search-live__status"><p>No matching books or authors</p></div>
          <a href="${viewAllUrl}" class="search-live-item search-live-item--all">View all search results</a>
        `;
        openResults();
        activeIndex = -1;
        input.removeAttribute("aria-activedescendant");
        return;
      }

      const itemsHtml = products
        .map((product, index) => {
          const productUrl = product.url || viewAllUrl;
          const productTitle = product.title || "Untitled";
          const productImage = getItemImage(product);
          const productPrice = getProductPriceText(product);
          const productAuthor = getProductAuthor(product);
          const itemId = `search-live-result-${index}`;
          const imageHtml = productImage
            ? `<figure class="search-live-item__thumb"><img src="${escapeHtml(
                normalizeImageUrl(productImage, 160)
              )}" alt="" loading="lazy"></figure>`
            : '<figure class="search-live-item__thumb"></figure>';

          return `
            <a
              id="${itemId}"
              href="${escapeHtml(productUrl)}"
              class="search-live-item"
              role="option"
              aria-selected="false"
              data-result-index="${index}"
            >
              ${imageHtml}
              <div class="search-live-item__content">
                <p class="search-live-item__title">${escapeHtml(productTitle)}</p>
                ${productAuthor ? `<p class="search-live-item__meta">Author: ${escapeHtml(productAuthor)}</p>` : ""}
                ${productPrice ? `<p class="search-live-item__price">${escapeHtml(productPrice)}</p>` : ""}
              </div>
            </a>
          `;
        })
        .join("");

      results.innerHTML = `
        ${itemsHtml}
        <a href="${viewAllUrl}" class="search-live-item search-live-item--all">View all search results</a>
      `;
      activeIndex = -1;
      input.removeAttribute("aria-activedescendant");
      openResults();
    }

    async function fetchProducts(query, token) {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
      const response = await fetch(url, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (token !== requestToken) {
        return null;
      }
      if (!response.ok) {
        throw new Error("Search request failed.");
      }
      const json = await response.json();
      return json && json.resources && json.resources.results && Array.isArray(json.resources.results.products)
        ? json.resources.results.products
        : [];
    }

    input.addEventListener("input", () => {
      const query = input.value.trim();
      window.clearTimeout(timeoutId);

      if (query.length < 2) {
        closeResults();
        results.innerHTML = "";
        return;
      }

      const token = requestToken + 1;
      requestToken = token;
      setStatus("Searching books and authors...", true);

      timeoutId = window.setTimeout(async () => {
        try {
          const products = await fetchProducts(query, token);
          if (products === null) {
            return;
          }

          let mergedProducts = Array.isArray(products) ? products.slice(0, 8) : [];

          if (mergedProducts.length === 0 && query.length >= 3) {
            try {
              const authorProducts = await fetchAuthorIndex();
              if (token !== requestToken) {
                return;
              }
              const authorMatches = getAuthorMatches(authorProducts, query, mergedProducts, 8);
              mergedProducts = mergedProducts.concat(authorMatches).slice(0, 8);
            } catch (authorError) {
              // Keep standard search behavior when author index fails.
            }
          }

          renderProducts(mergedProducts, query);
        } catch (error) {
          results.innerHTML = `
            <div class="search-live__status"><p>Unable to load suggestions</p></div>
            <a href="/search?q=${encodeURIComponent(query)}&type=product" class="search-live-item search-live-item--all">
              View all search results
            </a>
          `;
          openResults();
        }
      }, 180);
    });

    input.addEventListener("focus", () => {
      const query = input.value.trim();
      if (query.length >= 2 && results.innerHTML.trim() !== "") {
        openResults();
      }
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeResults();
        return;
      }

      const items = results.querySelectorAll(".search-live-item[data-result-index]");
      if (!items.length) {
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        setActiveItem(activeIndex + 1);
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        setActiveItem(activeIndex - 1);
        return;
      }

      if (event.key === "Enter" && activeIndex > -1) {
        const activeItem = items[activeIndex];
        if (activeItem && activeItem.getAttribute("href")) {
          event.preventDefault();
          const targetHref = activeItem.getAttribute("href");
          if (typeof window.bookmarkNavigateWithTransition === "function") {
            window.bookmarkNavigateWithTransition(targetHref);
          } else if (targetHref) {
            window.location.assign(targetHref);
          }
        }
      }
    });

    results.addEventListener("mousemove", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      const item = target.closest(".search-live-item[data-result-index]");
      if (!(item instanceof Element)) {
        return;
      }
      const nextIndex = Number(item.getAttribute("data-result-index"));
      if (Number.isInteger(nextIndex) && nextIndex !== activeIndex) {
        setActiveItem(nextIndex);
      }
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }
      if (!searchRoot.contains(target)) {
        closeResults();
      }
    });
  }

  function initSearchResultsAuthorMatches() {
    if (!window.location.pathname.startsWith("/search")) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const query = String(params.get("q") || "").trim();
    if (query.length < 2) {
      return;
    }

    const searchType = String(params.get("type") || "").toLowerCase();
    if (searchType) {
      const requestedTypes = searchType
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);
      if (requestedTypes.length && !requestedTypes.includes("product")) {
        return;
      }
    }

    const searchRoot = document.querySelector(".bookmark-search");
    const resultsRoot = searchRoot ? searchRoot.querySelector(".bookmark-search-results") : null;
    if (!searchRoot || !resultsRoot) {
      return;
    }
    const configuredLimit = Number(searchRoot.getAttribute("data-results-per-page"));
    const maxResults = Number.isInteger(configuredLimit) && configuredLimit > 0 ? configuredLimit : 16;

    function normalizeSearchValue(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/\s+/g, " ")
        .trim();
    }

    function normalizeProductUrlKey(url) {
      if (!url) {
        return "";
      }
      try {
        const parsed = new URL(String(url), window.location.origin);
        return `${parsed.pathname}${parsed.search}`.toLowerCase();
      } catch (error) {
        return String(url).trim().toLowerCase();
      }
    }

    function getProductKey(product) {
      if (!product || typeof product !== "object") {
        return "";
      }
      if (typeof product.url === "string" && product.url.trim()) {
        return normalizeProductUrlKey(product.url);
      }
      if (product.id !== null && product.id !== undefined) {
        return String(product.id).toLowerCase();
      }
      return "";
    }

    function getProductAuthor(product) {
      if (!product || typeof product !== "object") {
        return "";
      }
      if (typeof product.author === "string") {
        return product.author.trim();
      }
      return "";
    }

    function getProductPriceText(product) {
      if (!product || typeof product !== "object") {
        return "";
      }

      const candidates = [product.price, product.price_min, product.min_price, product.compare_at_price];
      for (const candidate of candidates) {
        if (candidate === null || candidate === undefined || candidate === "") {
          continue;
        }

        if (typeof candidate === "number" && Number.isFinite(candidate)) {
          return formatMoney(candidate);
        }

        if (typeof candidate === "string") {
          const raw = candidate.trim();
          if (!raw) {
            continue;
          }

          if (/[$€£₱]/.test(raw)) {
            return raw;
          }

          const numeric = Number(raw.replace(/,/g, ""));
          if (Number.isFinite(numeric)) {
            if (raw.includes(".")) {
              return formatMoney(Math.round(numeric * 100));
            }
            return formatMoney(numeric);
          }
        }
      }

      return "";
    }

    function getItemImage(product) {
      if (!product || !product.image) {
        return "";
      }
      if (typeof product.image === "string") {
        return product.image;
      }
      if (typeof product.image === "object" && typeof product.image.url === "string") {
        return product.image.url;
      }
      return "";
    }

    async function fetchAuthorIndex() {
      const authorProducts = [];
      let page = 1;
      let pages = 1;
      const maxPages = 40;

      while (page <= pages && page <= maxPages) {
        const url = `/search?q=*&type=product&view=author-index&page=${page}`;
        const response = await fetch(url, {
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });

        if (!response.ok) {
          throw new Error("Author index request failed.");
        }

        const json = await response.json();
        const products = json && Array.isArray(json.products) ? json.products : [];
        for (const product of products) {
          if (getProductAuthor(product)) {
            authorProducts.push(product);
          }
        }

        const totalPages = Number(json && json.pages);
        pages = Number.isInteger(totalPages) && totalPages > 0 ? totalPages : page;
        page += 1;
      }

      return authorProducts;
    }

    function getExistingProductKeys() {
      const keys = new Set();
      const existingProductLinks = resultsRoot.querySelectorAll(".bookmark-search-card--product .bookmark-search-card__link[href]");
      existingProductLinks.forEach((link) => {
        const key = normalizeProductUrlKey(link.getAttribute("href"));
        if (key) {
          keys.add(key);
        }
      });
      return keys;
    }

    function getAuthorMatches(authorProducts, searchQuery, existingKeys, limit) {
      if (!Array.isArray(authorProducts) || !authorProducts.length) {
        return [];
      }

      const normalizedQuery = normalizeSearchValue(searchQuery);
      if (!normalizedQuery) {
        return [];
      }

      const matches = [];
      const seenKeys = new Set(existingKeys || []);
      for (const product of authorProducts) {
        if (matches.length >= limit) {
          break;
        }

        const author = getProductAuthor(product);
        if (!author) {
          continue;
        }
        if (!normalizeSearchValue(author).includes(normalizedQuery)) {
          continue;
        }

        const key = getProductKey(product);
        if (key && seenKeys.has(key)) {
          continue;
        }
        if (key) {
          seenKeys.add(key);
        }

        matches.push(product);
      }

      return matches;
    }

    function renderAuthorMatches(products) {
      const cardsHtml = products
        .map((product) => {
          const productUrl = product.url || `/search?q=${encodeURIComponent(query)}&type=product`;
          const productTitle = product.title || "Untitled";
          const productAuthor = getProductAuthor(product);
          const productCollection =
            typeof product.collection === "string" && product.collection.trim() ? product.collection.trim() : "Book";
          const productPrice = getProductPriceText(product);
          const productImage = getItemImage(product);
          const placeholderLetter = productTitle.charAt(0) || "B";

          const imageHtml = productImage
            ? `<figure class="bookmark-search-card__image"><img src="${escapeHtml(
                normalizeImageUrl(productImage, 900)
              )}" alt="${escapeHtml(productTitle)}" loading="lazy"></figure>`
            : `<figure class="bookmark-search-card__image is-placeholder"><span class="bookmark-search-card__placeholder-text">${escapeHtml(
                placeholderLetter
              )}</span></figure>`;

          return `
            <article class="bookmark-search-card bookmark-search-card--product">
              <a class="bookmark-search-card__link" href="${escapeHtml(productUrl)}">
                ${imageHtml}
                <div class="bookmark-search-card__body">
                  <div class="bookmark-search-card__topline">
                    <span class="bookmark-search-card__badge">${escapeHtml(productCollection)}</span>
                  </div>
                  <h2>${escapeHtml(productTitle)}</h2>
                  ${productAuthor ? `<p class="bookmark-search-card__author">By ${escapeHtml(productAuthor)}</p>` : ""}
                  ${productPrice ? `<p class="bookmark-search-card__price"><strong>${escapeHtml(productPrice)}</strong></p>` : ""}
                </div>
              </a>
            </article>
          `;
        })
        .join("");

      let grid = resultsRoot.querySelector(".bookmark-search-grid");
      if (!grid) {
        grid = document.createElement("div");
        grid.className = "bookmark-search-grid";
        resultsRoot.appendChild(grid);
      }
      const emptyState = resultsRoot.querySelector(".bookmark-search-empty");
      if (emptyState) {
        emptyState.remove();
      }
      grid.insertAdjacentHTML("beforeend", cardsHtml);
    }

    const existingKeys = getExistingProductKeys();
    const existingCount = existingKeys.size;
    const emptyState = resultsRoot.querySelector(".bookmark-search-empty");
    const remainingSlots = Math.max(0, maxResults - existingCount);
    const matchLimit = remainingSlots > 0 ? remainingSlots : emptyState ? maxResults : 0;
    if (matchLimit <= 0) {
      return;
    }

    fetchAuthorIndex()
      .then((authorProducts) => {
        const authorMatches = getAuthorMatches(authorProducts, query, existingKeys, matchLimit);
        if (!authorMatches.length) {
          return;
        }
        renderAuthorMatches(authorMatches);
      })
      .catch(() => {
        // Keep the default empty-state experience if the author index request fails.
      });
  }

  function initSliders() {
    if (typeof window.Swiper === "undefined") {
      return;
    }

    const sliders = document.querySelectorAll(".js-bookmark-swiper");
    sliders.forEach((slider) => {
      const sliderId = slider.dataset.sliderId || slider.dataset.sectionId;
      const nextEl = sliderId ? `.swiper-button-next-${sliderId}` : null;
      const prevEl = sliderId ? `.swiper-button-prev-${sliderId}` : null;
      new window.Swiper(slider, {
        slidesPerView: 2.25,
        spaceBetween: 12,
        loop: false,
        breakpoints: {
          900: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl,
          prevEl
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initPageTransitions();
    initDrawer();
    initTopNavDropdowns();
    initStickyTopNav();
    initUtilityPanels();
    initAjaxCart();
    initSearch();
    initSearchResultsAuthorMatches();
    initSliders();
  });
})();
